import { getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { Guid } from 'zr-arch';

export type 提示类型 = '信息' | '成功' | '警告' | '错误';

export class 提示 {
    constructor(类型: 提示类型, 消息: string) {
        this.类型 = 类型;
        this.消息 = 消息;
    }

    标识: string = Guid.create().toString();
    类型: 提示类型;
    消息: string;
}

@Module({
    name: 'NotifyState',
    dynamic: true,
    namespaced: true,
    store: store,
})
export default class NotifyState extends VuexModule {
    提示表: 提示[] = [];

    @Mutation
    新增提示(提示: 提示) {
        this.提示表.push(提示);
    }

    @Mutation
    去除提示(标识: string) {
        const find = this.提示表.find((x) => x.标识 === 标识);
        if (find) this.提示表.splice(this.提示表.indexOf(find), 1);
    }
}

export const 提示状态 = getModule(NotifyState);
